
    import '/home/ec2-user/Youlify-Design/components/tour/index.zh-CN.md?watch=parent';
    export const demoIndex = {
  ids: ["tour-demo-basic","tour-demo-non-modal","tour-demo-placement","tour-demo-mask","tour-demo-indicator","tour-demo-gap","tour-demo-render-panel"],
  getter: () => import(/* webpackChunkName: "meta__components__zh-CN" */'/home/ec2-user/Youlify-Design/components/tour/index.zh-CN.md?type=demo')
};